import React from 'react';
import CleverIcon from '../assets/icons/clever.svg';
import signInStyle from '../styles/SignIn.module.scss';

const CleverButton = ({ onClick, text, disabled }) => {
  return (
    <button
      className={signInStyle['sign-in-button-external']}
      onClick={onClick}
      disabled={disabled}
    >
      <img src={CleverIcon} alt={'Clever logo'} className="float-left" />
      <span>{text}</span>
    </button>
  );
};

CleverButton.defaultProps = {
  onClick: () => {},
  text: '',
};

export default CleverButton;
